import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { QuickBriefService } from '../../services/quick-brief.service';

@Component({
  selector: 'qb-format-step',
  templateUrl: './format-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex min-h-0 flex-1 flex-col overflow-hidden' },
})
export class QbFormatStep {
  readonly brief = inject(QuickBriefService);

  optionClass(selected: boolean): string {
    return selected
      ? 'border-2 border-primary bg-primary/5'
      : 'border border-border bg-card hover:border-primary';
  }
}
